// Croatian

export default {

  component: {
    jobAdList: {
      title: 'Otvoreni oglasi za posao',
      jobs: 'poslovi',
      noJobAds: 'Trenutno nema otvorenih oglasa za posao.',
    },

    jobAdCard: {
      openUntil: date => `Otvoreno do ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Hvala.',
      readyInfo: 'Vaša je prijava sada zaprimljena i regruter će vam se ubrzo javiti.',
      luck: 'Sretno!',
    },

    jobAdSeeYou: {
      title: 'Hvala.',
      description: 'Vaša je prijava spremljena i poslali smo vam poveznicu ako poslije budete željeli nastaviti s postupkom prijave.',
    },

    unpublished: {
      title: 'Neobjavljen',
      info: 'Ovaj oglas za posao još nije objavljen.',
    },
  },

  page: {},

}
